import { CompanyId } from '@/domain/models/company/company-id'
import { CountryId } from '@/domain/models/country'

export const getLanguage = (countryId: CountryId, companyId: CompanyId) => `${CompanyId[companyId].toUpperCase()}_${countryId}`
